import { useEffect, useState } from "react";
import Deadline from "../deadline"
import moment from "moment";
import editIcon from '../images/edit-icon.svg'
import DatePickerInput from "./DatePickerInput";

export interface ProgressDeadlineProps {
    selectedDate: any;
    setSelectedDate: (value: moment.Moment) => void;
    isCompleted: boolean;
    loading?: boolean;
}


export default function ProgressDeadline({ selectedDate, setSelectedDate, isCompleted, loading }: ProgressDeadlineProps) {

    const [deadlineDate, setDeadlineDate] = useState(new Deadline(new Date(selectedDate.format('YYYY-MM-DD'))));

    const styles = {
        color: isCompleted ? '#BDBDBD' : deadlineDate.deadlineColor,
    }

    const [edit, setEdit] = useState(false)

    const handleEditDeadline = () => {
        setEdit(true)
    }

    useEffect(() => {
        setDeadlineDate(new Deadline(new Date(selectedDate.format('YYYY-MM-DD'))))
    }, [selectedDate])

    return (
        <>
            <div className="ProgressDialog-deadline" style={styles}>
                <div style={{ display: 'flex', gap: '0.75rem' }}>
                    {!edit && <h5 className="ProgressDialog-date">{deadlineDate.deadline}</h5>}
                    {edit && (
                        <div style={{ width: '100px' }}>
                            <DatePickerInput
                                label='Due Date'
                                emptyLabel='Select Date'
                                selectedDate={selectedDate}
                                setSelectedDate={setSelectedDate}
                                disabled={loading || isCompleted}
                                inputVariant="standard"
                            />
                        </div>
                    )}

                    {!edit && !isCompleted && selectedDate && <button type="button" className="ProgressDialog-edit-info-btn" onClick={handleEditDeadline} disabled={loading}><img src={editIcon} alt="editIcon"/> Edit</button>}
                </div>
                {
                    !isCompleted && !edit &&
                    <div className="flex gap-dot25">
                            <img src={deadlineDate.srcIcon} alt="" />
                            <h5 className="CommonGoal-countdown">{deadlineDate.diffDaysText}</h5>
                        </div>
                }
            </div>
        </>
    )
}